module.exports = __webpack_public_path__ + "img/app@2x.6b0daeed.png";